import React from 'react';
import ComponentCreator from '@docusaurus/ComponentCreator';

export default [
  {
    path: '/cs/501/',
    component: ComponentCreator('/cs/501/', '600'),
    exact: true
  },
  {
    path: '/cs/articles/',
    component: ComponentCreator('/cs/articles/', '1d1'),
    exact: true
  },
  {
    path: '/cs/articles/2024/07/09/diskusija-lj-nj-cyrl/',
    component: ComponentCreator('/cs/articles/2024/07/09/diskusija-lj-nj-cyrl/', '6ef'),
    exact: true
  },
  {
    path: '/cs/articles/2024/07/09/diskusija-lj-nj/',
    component: ComponentCreator('/cs/articles/2024/07/09/diskusija-lj-nj/', '52c'),
    exact: true
  },
  {
    path: '/cs/articles/archive/',
    component: ComponentCreator('/cs/articles/archive/', '044'),
    exact: true
  },
  {
    path: '/cs/articles/authors/',
    component: ComponentCreator('/cs/articles/authors/', '592'),
    exact: true
  },
  {
    path: '/cs/search/',
    component: ComponentCreator('/cs/search/', 'e3c'),
    exact: true
  },
  {
    path: '/cs/',
    component: ComponentCreator('/cs/', '013'),
    exact: true
  },
  {
    path: '/cs/',
    component: ComponentCreator('/cs/', '72f'),
    routes: [
      {
        path: '/cs/',
        component: ComponentCreator('/cs/', '448'),
        routes: [
          {
            path: '/cs/tags/',
            component: ComponentCreator('/cs/tags/', 'f6f'),
            exact: true
          },
          {
            path: '/cs/tags/comparative/',
            component: ComponentCreator('/cs/tags/comparative/', '08b'),
            exact: true
          },
          {
            path: '/cs/tags/gramatika/',
            component: ComponentCreator('/cs/tags/gramatika/', '458'),
            exact: true
          },
          {
            path: '/cs/tags/grammar/',
            component: ComponentCreator('/cs/tags/grammar/', '610'),
            exact: true
          },
          {
            path: '/cs/tags/interslavic/',
            component: ComponentCreator('/cs/tags/interslavic/', '4fe'),
            exact: true
          },
          {
            path: '/cs/tags/language-learning/',
            component: ComponentCreator('/cs/tags/language-learning/', '2e0'),
            exact: true
          },
          {
            path: '/cs/tags/linguistics/',
            component: ComponentCreator('/cs/tags/linguistics/', 'df8'),
            exact: true
          },
          {
            path: '/cs/tags/mezislovansky-jazyk/',
            component: ComponentCreator('/cs/tags/mezislovansky-jazyk/', '98f'),
            exact: true
          },
          {
            path: '/cs/tags/mezislovanstina/',
            component: ComponentCreator('/cs/tags/mezislovanstina/', 'a04'),
            exact: true
          },
          {
            path: '/cs/tags/personal-pronouns/',
            component: ComponentCreator('/cs/tags/personal-pronouns/', '0d8'),
            exact: true
          },
          {
            path: '/cs/tags/podstatna-jmena/',
            component: ComponentCreator('/cs/tags/podstatna-jmena/', '4d3'),
            exact: true
          },
          {
            path: '/cs/tags/pronouns/',
            component: ComponentCreator('/cs/tags/pronouns/', '0f7'),
            exact: true
          },
          {
            path: '/cs/tags/slavic-languages/',
            component: ComponentCreator('/cs/tags/slavic-languages/', '332'),
            exact: true
          },
          {
            path: '/cs/tags/srovnani-jazyku/',
            component: ComponentCreator('/cs/tags/srovnani-jazyku/', 'bf1'),
            exact: true
          },
          {
            path: '/cs/tags/studium-jazyka/',
            component: ComponentCreator('/cs/tags/studium-jazyka/', '813'),
            exact: true
          },
          {
            path: '/cs/tags/uceni-jazyka/',
            component: ComponentCreator('/cs/tags/uceni-jazyka/', 'a06'),
            exact: true
          },
          {
            path: '/cs/tags/uceni-se-jazyka/',
            component: ComponentCreator('/cs/tags/uceni-se-jazyka/', 'c81'),
            exact: true
          },
          {
            path: '/cs/tags/zajmena/',
            component: ComponentCreator('/cs/tags/zajmena/', 'c80'),
            exact: true
          },
          {
            path: '/cs/',
            component: ComponentCreator('/cs/', 'e11'),
            routes: [
              {
                path: '/cs/learn/faq/',
                component: ComponentCreator('/cs/learn/faq/', '5c2'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/cs/learn/grammar/',
                component: ComponentCreator('/cs/learn/grammar/', '5ab'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/cs/learn/grammar/adjectives/',
                component: ComponentCreator('/cs/learn/grammar/adjectives/', '8b2'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/cs/learn/grammar/conjunctions/',
                component: ComponentCreator('/cs/learn/grammar/conjunctions/', '9ed'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/cs/learn/grammar/nouns/',
                component: ComponentCreator('/cs/learn/grammar/nouns/', 'a29'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/cs/learn/grammar/numerals/',
                component: ComponentCreator('/cs/learn/grammar/numerals/', '9b1'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/cs/learn/grammar/prepositions/',
                component: ComponentCreator('/cs/learn/grammar/prepositions/', '4ef'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/cs/learn/grammar/pronouns/',
                component: ComponentCreator('/cs/learn/grammar/pronouns/', 'a5e'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/cs/learn/grammar/syntax/',
                component: ComponentCreator('/cs/learn/grammar/syntax/', 'c60'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/cs/learn/grammar/verbs/',
                component: ComponentCreator('/cs/learn/grammar/verbs/', '937'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/cs/learn/introduction/',
                component: ComponentCreator('/cs/learn/introduction/', 'efc'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/cs/learn/misc/constructed-slavic-languages/',
                component: ComponentCreator('/cs/learn/misc/constructed-slavic-languages/', '8d4'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/cs/learn/misc/design-criteria/',
                component: ComponentCreator('/cs/learn/misc/design-criteria/', 'ac0'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/cs/learn/misc/history/',
                component: ComponentCreator('/cs/learn/misc/history/', '868'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/cs/learn/misc/language-comparison/',
                component: ComponentCreator('/cs/learn/misc/language-comparison/', '3b4'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/cs/learn/misc/numbers-1-10/',
                component: ComponentCreator('/cs/learn/misc/numbers-1-10/', 'ca8'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/cs/learn/misc/pan-slavic-relay/',
                component: ComponentCreator('/cs/learn/misc/pan-slavic-relay/', '630'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/cs/learn/misc/personal-pronouns/',
                component: ComponentCreator('/cs/learn/misc/personal-pronouns/', 'c03'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/cs/learn/orthography/',
                component: ComponentCreator('/cs/learn/orthography/', '98f'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/cs/learn/phonology/',
                component: ComponentCreator('/cs/learn/phonology/', 'd23'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/cs/learn/pronunciation/',
                component: ComponentCreator('/cs/learn/pronunciation/', 'ec4'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/cs/learn/simple-grammar/',
                component: ComponentCreator('/cs/learn/simple-grammar/', 'ac4'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/cs/learn/simple-grammar/level-1/',
                component: ComponentCreator('/cs/learn/simple-grammar/level-1/', 'a94'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/cs/learn/simple-grammar/level-2/',
                component: ComponentCreator('/cs/learn/simple-grammar/level-2/', '302'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/cs/learn/vocabulary/derivation/',
                component: ComponentCreator('/cs/learn/vocabulary/derivation/', 'fea'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/cs/learn/vocabulary/flavourisation/',
                component: ComponentCreator('/cs/learn/vocabulary/flavourisation/', 'b84'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/cs/learn/vocabulary/word-formation/',
                component: ComponentCreator('/cs/learn/vocabulary/word-formation/', 'd00'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/cs/resources/',
                component: ComponentCreator('/cs/resources/', '9c9'),
                exact: true,
                sidebar: "resourcesSidebar"
              },
              {
                path: '/cs/resources/applets/',
                component: ComponentCreator('/cs/resources/applets/', 'db2'),
                exact: true,
                sidebar: "resourcesSidebar"
              },
              {
                path: '/cs/resources/applets/intelligibility/',
                component: ComponentCreator('/cs/resources/applets/intelligibility/', '11c'),
                exact: true,
                sidebar: "resourcesSidebar"
              },
              {
                path: '/cs/resources/applets/transliterator/',
                component: ComponentCreator('/cs/resources/applets/transliterator/', '014'),
                exact: true,
                sidebar: "resourcesSidebar"
              },
              {
                path: '/cs/resources/keyboards/',
                component: ComponentCreator('/cs/resources/keyboards/', '63f'),
                exact: true,
                sidebar: "resourcesSidebar"
              }
            ]
          }
        ]
      }
    ]
  },
  {
    path: '*',
    component: ComponentCreator('*'),
  },
];
